import { render, staticRenderFns } from "./InstitutionalExportList.vue?vue&type=template&id=21331c86"
import script from "./InstitutionalExportList.vue?vue&type=script&lang=js"
export * from "./InstitutionalExportList.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalExportList.vue?vue&type=style&index=0&id=21331c86&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports